import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { CommitteeMeetingMemberAttendanceSearchDto } from 'src/app/committees/shared/dto/committee-meeting-member-attendance-search.dto';
import { CommitteeMeetingMemberAttendanceDto } from 'src/app/committees/shared/dto/committee-meeting-member-attendance.dto';
import { PagedResultGeneric, DatagridService, NotificationService } from 'src/app/shared';
import { CommitteeMeetingService } from 'src/app/committees/shared/committee-meeting.service';
import { CommitteeMeetingAttendeeService } from 'src/app/committees/shared/committee-meeting-attendee.service';
import { initializedCommitteeMeetingAttendeeDto } from 'src/app/committees/shared/dto/committee-meeting-attendee.dto';

@Component({
  selector: 'wl-committee-meeting-attendance-grid',
  templateUrl: './committee-meeting-attendance-grid.component.html',
  styleUrls: ['./committee-meeting-attendance-grid.component.less'],
    standalone: false
})
export class CommitteeMeetingAttendanceGridComponent
  extends LazySelectableTableComponent<CommitteeMeetingMemberAttendanceSearchDto, CommitteeMeetingMemberAttendanceDto>
  implements OnInit, OnChanges {
  @Input() meetingId: number;

  constructor(
    datagridService: DatagridService,
    private _committeeMeetingService: CommitteeMeetingService,
    private _committeeMeetingAttendeeService: CommitteeMeetingAttendeeService,
    private _notificationService: NotificationService
  ) {
    super('AttendeeID', datagridService);
  }

  ngOnInit(): void {}

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.meetingId && this.meetingId) {
      this.searchParams = new CommitteeMeetingMemberAttendanceSearchDto();
      this.searchParams.PageSize = 9999;
      this.searchParams.MeetingID = this.meetingId;
    }
  }

  fetchResults(): Promise<PagedResultGeneric<CommitteeMeetingMemberAttendanceDto>> {
    return this._committeeMeetingService.searchMeetingAttendance(this.searchParams);
  }

  attendedChanged(memberAttendance: CommitteeMeetingMemberAttendanceDto) {
    if (!memberAttendance.AttendeeID) {
      const attendee = initializedCommitteeMeetingAttendeeDto(
        memberAttendance.MeetingID,
        memberAttendance.CommitteeID,
        memberAttendance.ProfileID
      );
      this._committeeMeetingAttendeeService
        .create(attendee)
        .then((id) => {
          this._notificationService.translateSuccess('committees.edit.committee-meetings.attendance.updated-attendance');
          memberAttendance.AttendeeID = id;
        })
        .catch((err) => {
          this._notificationService.httpError(err);
          memberAttendance.Attended = !memberAttendance.Attended;
        });
    } else {
      this._committeeMeetingAttendeeService
        .delete(memberAttendance.AttendeeID)
        .then(() => {
          this._notificationService.translateSuccess('committees.edit.committee-meetings.attendance.updated-attendance');
          this.search();
        })
        .catch((err) => {
          this._notificationService.httpError(err);
          memberAttendance.Attended = !memberAttendance.Attended;
        });
    }
  }

  removeGuest(memberAttendance: CommitteeMeetingMemberAttendanceDto) {
    this.loading = true;
    this._committeeMeetingAttendeeService
      .delete(memberAttendance.AttendeeID)
      .then(() => {
        this._notificationService.translateSuccess('committees.edit.committee-meetings.attendance.removed-guest');
        this.search();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
